import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ─── Aggressive suppression of CRA error overlay ───
// Telegram WebView and cross-origin scripts cause "Script error."
// which triggers the ugly red React error overlay in dev mode.

// 1. Catch at the earliest possible moment
window.addEventListener("error", (e) => {
  if (!e.message || e.message === "Script error." || e.message === "Script error" || e.message.includes("Script error")) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
}, true); // capture phase = earliest

window.addEventListener("unhandledrejection", (e) => {
  if (!e.reason || e.reason?.message?.includes?.("Script error")) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}, true);

// 2. MutationObserver to instantly remove error overlay elements
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1) {
        // Remove CRA error overlay iframe
        if (node.tagName === "IFRAME" && (node.id?.includes("overlay") || (node.style && parseInt(node.style.zIndex) > 999))) {
          node.remove();
          continue;
        }
        // Remove webpack-dev-server overlay
        if (node.id === "webpack-dev-server-client-overlay" || node.id === "webpack-dev-server-client-overlay-div") {
          node.remove();
          continue;
        }
        // Remove any element with very high z-index that looks like an error overlay
        if (node.style && parseInt(node.style.zIndex) >= 2147483000) {
          node.remove();
          continue;
        }
      }
    }
  }
});
observer.observe(document.documentElement, { childList: true, subtree: true });

// 3. Also periodically clean up (fallback)
setInterval(() => {
  document.querySelectorAll("iframe[id*='overlay'], #webpack-dev-server-client-overlay, #webpack-dev-server-client-overlay-div").forEach(el => el.remove());
  document.querySelectorAll("body > div").forEach(el => {
    if (el.style && parseInt(el.style.zIndex) >= 2147483000) el.remove();
  });
}, 500);

// ─── Error Boundary ───
class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(err) { console.warn("ErrorBoundary caught:", err.message); }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{minHeight:"100vh",background:"#000",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:"16px"}}>
          <p style={{fontFamily:"Oswald,sans-serif",fontSize:"24px",letterSpacing:"2px"}}>Amberglow</p>
          <p style={{color:"#666",fontSize:"14px"}}>Произошла ошибка. Обновите страницу.</p>
          <button onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
            style={{padding:"8px 24px",background:"#fff",color:"#000",border:"none",cursor:"pointer",fontFamily:"Oswald,sans-serif",fontSize:"12px",letterSpacing:"1px"}}>
            ОБНОВИТЬ
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
